import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress, TextField } from "@mui/material";

export default function Asynchronous(props) {
  const {
    getOptionLabel,
    Service,
    value,
    inputProps,
    variant,
    onChange,
    ...rest
  } = props;

  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputValueChange = (e, newValue) => {
    setInputValue(newValue);

    if (newValue.length === 1 && newValue === "A") {
      setLoading(false);
      setInputValue("");
      return;
    }

    if (newValue.length > 0) {
      setLoading(true);
    } else {
      setOptions([]);
    }

    if (newValue.length >= 3) {
      (async () => {
        const response = await Service(newValue);
        setOptions(response);
        setLoading(false);

        // Automatically select if only one option is available
        if (response.length === 1) {
          onChange(null, response[0]); // Trigger onChange with the selected option
          setInputValue(
            getOptionLabel
              ? getOptionLabel(response[0])
              : response[0].name + " | " + response[0].barcode
          );
        }
      })();
    }
  };

  useEffect(() => {
    if (open && options.length === 0) {
      setLoading(true);
    }
  }, [open, options.length]);

  return (
    <Autocomplete
      autoHighlight
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => {
        setOpen(true);
      }}
      clearOnEscape
      value={value === "" ? null : value}
      getOptionLabel={
        getOptionLabel
          ? getOptionLabel
          : (option) => option.name + " | " + option.barcode
      }
      {...rest}
      options={options}
      loading={loading}
      inputValue={inputValue}
      onInputChange={handleInputValueChange}
      onChange={onChange} // Ensure the parent component receives updates
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProps}
          variant={variant ? variant : "outlined"}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && open ? (
                  <CircularProgress color="inherit" size={15} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
